module.exports = __webpack_public_path__ + "static/media/loader.6a89a6c7.svg";